import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Address } from '../../models/Addresses';
import { User } from '../../models/User';

const initialState: ProfileEditorState = {
    dialog: {
        profile: {
            open: false,
        },
        address: {
            open: false,
        },
        adminAddress: {
            open: false,
            type: null,
        },
    },
    selectedAddress: null,
    selectedUser: null,
    selectedUserId: null,
    isAdmin: false,
    addressDialogClosedWithSuccess: false,
    profileDialogClosedWithSuccess: false,
};

export const profileDialogSlice = createSlice({
    name: 'profile-dialog',
    initialState,
    reducers: {
        setDialogOpen: (state, action: PayloadAction<setDialogOpenPayload>) => {
            state.dialog[action.payload.dialog].open = action.payload.open;
            if (action.payload.type) {
                state.dialog[action.payload.dialog].type = action.payload.type;
            }
        },
        setSelectedAddress: (state, action: PayloadAction<Address>) => {
            state.selectedAddress = action.payload;
        },
        setSelectedUser: (state, action: PayloadAction<any>) => {
            state.selectedUser = action.payload;
        },
        setIsAdmin: (state, action: PayloadAction<boolean>) => {
            state.isAdmin = action.payload;
        },
        setSelectedUserId: (state, action: PayloadAction<number>) => {
            state.selectedUserId = action.payload;
        },
        setAddressDialogClosedWithSuccess: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.addressDialogClosedWithSuccess = action.payload;
        },
        setProfileDialogClosedWithSuccess: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.profileDialogClosedWithSuccess = action.payload;
        },
    },
});

export interface ProfileEditorState {
    dialog: Dialogs;
    selectedAddress: Address;
    selectedUser: User;
    selectedUserId: number;
    isAdmin: boolean;
    addressDialogClosedWithSuccess: boolean;
    profileDialogClosedWithSuccess: boolean;
}

interface DialogState {
    open: boolean;
    type?: 'shipping' | 'billing';
}

interface Dialogs {
    profile: DialogState;
    address: DialogState;
    adminAddress: DialogState;
}

interface setDialogOpenPayload {
    dialog: keyof Dialogs;
    open: boolean;
    type?: 'shipping' | 'billing' | null;
}

export const profileDialogAction = profileDialogSlice.actions;

export default profileDialogSlice.reducer;
